/**
 * Mask customer email during while logging context.
 * @param email
 */
export const maskEmail = (email) => {
    if (!email) {
        return 'UNDEFINED_EMAIL';
    }
    const digitsToLeaveOut = 3;
    // check if email is less or equal to 3 digits
    if (email.length <= digitsToLeaveOut) {
        return email;
    }
    const numberOfMaskedDigits = email.length - digitsToLeaveOut;
    const leftOutDigits = email.substring(0, digitsToLeaveOut);
    const maskedDigits = '*'.repeat(numberOfMaskedDigits);
    return `${leftOutDigits}${maskedDigits}`;
};
/**
 * Mask customer phone number during while logging context.
 * @param phone
 */
export const maskPhoneNumber = (phoneNumber) => {
    if (!phoneNumber || phoneNumber === 'UNDEFINED_CUSTOMER_NUMBER') {
        return 'UNDEFINED_CUSTOMER_NUMBER';
    }
    const digitsToLeaveOut = 4;
    // check if phoneNumber is less or equal to 4 digits
    if (phoneNumber.length <= digitsToLeaveOut) {
        return phoneNumber;
    }
    const numberOfMaskedDigits = phoneNumber.length - digitsToLeaveOut;
    const leftOutDigits = phoneNumber.substring(0, digitsToLeaveOut);
    const maskedDigits = '*'.repeat(numberOfMaskedDigits);
    // return +134********
    return `${leftOutDigits}${maskedDigits}`;
};
//# sourceMappingURL=MaskCustomerData.js.map